const civServicesBaseURL = 'https://rpv.rabobank.nl/civ_services';
const civViewBaseURL = 'https://rpv.rabobank.nl/civ_view';
const clientId = 'ab70d836-3634-49c4-939f-7b27a2822fff';

const apiScopes = [
  'https://raboweb.onmicrosoft.com/RPV_MVP_MFA_PROD/User.Read'
];

/* This  function sends an ajax request with an arrangementnumber and admincode to a CIV controller.
The controller connects to a webservice and receives a siebel url. This url is returned to
the ajax request (as a json object).
*/
async function getArrangementUrl(arrangementNumber, adminCode, bankCode){

  let authorization = await getAuthorizationFromMSAL(clientId, apiScopes);

  var dataJson = {
    arrangementNumber : arrangementNumber,
    administrationCode : adminCode,
    bankCode : bankCode
  }
  $.ajax({
    type: 'POST',

    url: civViewBaseURL + '/getarrangementurl',
    data: JSON.stringify(dataJson),
    headers: {
      'Authorization':authorization.idToken,
      'MFA-Authorization':authorization.idToken,
      'Graph-Authorization': authorization.graphToken
    },
    contentType: 'application/json',
    success: function(data){
      if (data !== null){
        var url = data.url;
        if (url !== null){
          window.open(url, 'SIEBEL');
        }
      }
    },
    error: function(xhr, textStatus, error){
      // do nothing
    }
  });

}

async function loadView(view, arrangementNumber, adminCode, id, moreThanOnce) {

  let authorization = await getAuthorizationFromMSAL(clientId, apiScopes);

  var dataJson = {
    arrangementNumber : arrangementNumber,
    administrationCode : adminCode,
  }
  $.ajax({
    type: 'POST',
    url: civViewBaseURL + '/productoverview/' + view,
    data: JSON.stringify(dataJson),
    headers: {
      'Authorization':authorization.idToken,
      'MFA-Authorization':authorization.idToken,
      'Graph-Authorization': authorization.graphToken
    },
    contentType: 'application/json',
    success: function(result){
      $('#' + view).html($(result).filter('#content'));

      if(id !== '') {
        clickAuthorisationRadio(id);
      }
    },
    error: function(xhr, textStatus, error){
      $('#' + view).html($(xhr));
    }
  });
}

async function openPopup(event, url, popupId, formId) {

  let authorization = await getAuthorizationFromMSAL(clientId, apiScopes);

  var baseUrl = civViewBaseURL + "/productoverview/";
  var endUrl = url.split("/", 3)[2];
  var newUrl = baseUrl + endUrl;
  if (isAsyncNotAvail()) {
    return true;
  } else {
    var request = getXmlHttpRequest();

    try {
      request.open('POST', newUrl, true);
    } catch (e) {
      return true;
    }

    request.onreadystatechange = function() {
      if (request.readyState === 4
        && (request.status === 200 || request.status === 403)
        && request.responseText) {

        clearTimeout(requestTimeout);
        let popup = document.getElementById(popupId);
        if (request.status === 403) {
          popup.style.backgroundColor = "white";
          popup.innerHTML = "Sessie is verlopen, kies opnieuw een klant";
        } else {
          // Response comes from CIV server, so no cross site
          // scripting threat.
          popup.innerHTML = request.responseText;
          //Trigger the popupInserted event
          if($('#' + popupId).trigger){
            $('#' + popupId).trigger('popupInsertedEvent');
          }
        }
        var error = document.getElementById('errorGrid');
        if (error !== null) {
          var rootElement = document.getElementById('treePanel').parentNode;

          rootElement.removeChild(document
            .getElementById('treePanel'));
          rootElement.removeChild(document
            .getElementById('loadingDiv'));

          rootElement.appendChild(error);
        } else {
          alignPopupInCenter(popupId);
          popup.style.visibility = 'visible';
          $('#' + popupId).show();
          //Trigger the popupInserted event
          if($('#' + popupId).trigger){
            $('#' + popupId).trigger('popupShowEvent');
          }
        }
      } else {
        return true;
      }

    };

    var requestTimeout = setTimeout(function() {
      ajaxTimeout(request);
    }, 15000);
    var params = getAllHiddenPopUpFields(formId, popupId);
    request.setRequestHeader("Content-type", "application/json");
    request.setRequestHeader("Authorization", authorization.idToken);
    request.setRequestHeader("MFA-Authorization", authorization.idToken);
    request.setRequestHeader("Graph-Authorization", authorization.graphToken);
    request.send(params);
  }

  return false;
}
